<template>
  <div
    id="create-supplier-modal"
    tabindex="-1"
    aria-hidden="true"
    class="fixed top-0 left-0 right-0 z-50 items-center justify-center hidden w-full overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full"
  >
    <div class="relative w-full max-w-4xl p-4">
      <!-- Modal content -->
      <div class="relative pt-4 pb-2 bg-gray-200 rounded-lg shadow  flex flex-col items-stretch" style="min-height: 600px">
        <!-- Modal header -->
        <div class="px-4 flex items-center justify-between pb-4 mb-4 border-b border-gray-200 rounded-t sm:mb-5 ">
          <h3 v-if="input?.id == undefined" class="font-semibold text-gray-900 text-lg ">{{ labels["TITLE_SUPPLIER"][lg] }} - {{ input?.id }} -</h3>

          <h3 v-if="input?.id != undefined" class="font-semibold text-gray-900 text-lg ">{{ labels["TITLE_SUPPLIER"][lg] }} - {{ input?.id }} -</h3>

          <button
            type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 inline-flex "
            @click="onClose()"
          >
            <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>
        <div class="items-stretch bg-white rid gap-4 mb-4 sm:grid-cols-1 sm:gap-6 sm:mb-5 p-4 h-full">
          <div class="w-full">
            <p class="text-sm font-normal text-gray-500 ">
              {{ labels["TITLE_SUPPLIER_DESCRIPTION"][lg] }}
            </p>

            <div class="mt-2 w-full flex flex-row text-left justify-left items-stretch">
              <div v-if="input?.id == undefined" class="flex flex-col items-center mb-4">
                <div class="mt-2 w-full text-left justify-left">
                  <label for="name" class="block mb-2 text-sm font-medium text-gray-900 "> {{ labels["TITLE_SUPPLIER_NAME"][lg] }}</label>

                  <div class="w-96 bg-white rounded-lg shadow ">
                    <div class="p-3">
                      <label for="input-group-search" class="sr-only">Search</label>
                      <div class="relative">
                        <div class="absolute inset-y-0 rtl:inset-r-0 start-0 flex items-center ps-3 pointer-events-none">
                          <svg class="w-4 h-4 text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                          </svg>
                        </div>
                        <input
                          id="input-group-search"
                          type="text"
                          v-model="query"
                          @keyup="openSearch"
                          class="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500      "
                          placeholder="Recherche d'un fournisseur"
                        />
                      </div>
                    </div>
                    <ul class="h-96 px-3 pb-3 overflow-y-auto text-sm " aria-labelledby="dropdownSearchButtonSuppliers">
                      <li v-for="supplier in filtered_suppliers" :key="supplier.id" class="cursor-pointer" @click="selectSupplier(supplier)">
                        <div
                          class="cursor-pointer flex items-center ps-2 rounded"
                          :class="{
                            'hover:bg-gray-500 bg-gray-700  text-white font-bold': supplier_id == supplier._id,
                            'hover:bg-gray-200 text-gray-700 ': supplier_id != supplier._id,
                          }"
                        >
                          <label for="checkbox-item-11" class="cursor-pointer w-full py-2 ms-2 text-sm rounded">
                            {{ supplier.name }}
                          </label>
                        </div>
                      </li>
                    </ul>
                    <a
                      href="#"
                      class="hidden items-center p-3 text-sm font-medium text-blue-600 border-t border-gray-200 rounded-b-lg bg-gray-50  hover:bg-gray-100   hover:underline"
                    >
                      <svg class="w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                        <path
                          d="M6.5 9a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM8 10H5a5.006 5.006 0 0 0-5 5v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-2a5.006 5.006 0 0 0-5-5Zm11-3h-6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2Z"
                        />
                      </svg>
                      Ajouter un fournisseur
                    </a>
                  </div>
                </div>
              </div>

              <div v-if="input?.id != undefined" class="w-96 flex flex-col items-center mb-4 bg-gray-50 px-6 justify-center">
                <img class="rounded-sm w-36 h-36" :src="`${host_media}${supplier.image_id}`"  alt="Extra large avatar" />

                <div class="mt-3 font-bold text-xl text-center px-6">{{ input?.supplier_name }}</div>
              </div>

              <div class="hidden flex flex-col items-center mb-4 w-full p-2">
                <div
                  v-for="(item, index) in products"
                  :key="index"
                  class="flex items-center mb-4 justify-start w-full border border-gray-100 p-2 cursor-pointer hover:bg-gray-100 rounded-lg  "
                  :class="{ 'border-gray-500 border-4 bg-gray-200': item._id == selected._id }"
                  @click="selectProduct(item)"
                >
                  <img v-if="item.image_id" :src="`https://files.b4food.io/b4food/images/${item?.image_id}?icon=true`" alt="" class="w-10 h-10 rounded-full mr-2" />
                  <span class="text-sm font-medium text-gray-900 ">{{ item.name }}</span>
                </div>
              </div>

              <div class="flex flex-col items-center mb-4">
                <div class="mt-16 w-full text-left justify-left flex">
                  <div class="w-full ml-2 text-left justify-left">
                    <label for="name" class="block mb-2 text-sm font-medium text-gray-900 "> {{ labels["TITLE_SUPPLIER_PRODUCT_NAME"][lg] }}</label>
                    <input
                      id="name"
                      v-model="name"
                      v-focus
                      type="text"
                      name="name"
                      class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-primary-600 focus:border-primary-600 block p-2.5      "
                      placeholder=""
                    />
                  </div>
                </div>

                <div class="mt-4 w-full text-left justify-left flex">
                  <div class="w-full ml-2 text-left justify-left">
                    <label for="name" class="block mb-2 text-sm font-medium text-gray-900 "> {{ labels["TITLE_SUPPLIER_PRODUCT_URL"][lg] }}</label>
                    <input
                      id="url"
                      v-model="url"
                      v-focus
                      type="text"
                      name="url"
                      class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-primary-600 focus:border-primary-600 block p-2.5      "
                      placeholder=""
                    />
                  </div>
                </div>

                <div class="mt-4 w-full text-left justify-left flex">
                  <div class="w-full ml-2 text-left justify-left">
                    <label for="name" class="block mb-2 text-sm font-medium text-gray-900 "> {{ labels["TITLE_SUPPLIER_PACKAGING"][lg] }}</label>
                    <input
                      id="quantity"
                      v-model="quantity"
                      v-focus
                      type="text"
                      name="quantity"
                      class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-primary-600 focus:border-primary-600 block p-2.5      "
                      placeholder=""
                    />
                  </div>
                </div>

                <div class="mt-6 w-full text-left justify-left flex">
                  <div class="w-full ml-2 text-left justify-left">
                    <label for="name" class="block mb-2 text-sm font-medium text-gray-900 "> {{ labels["TITLE_SUPPLIER_REFERENCE"][lg] }}</label>
                    <input
                      id="reference"
                      v-model="reference"
                      v-focus
                      type="text"
                      name="reference"
                      class="w-48 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-primary-600 focus:border-primary-600 block p-2.5      "
                      placeholder=""
                    />
                  </div>
                  <div class="w-full ml-2 text-left justify-left">
                    <label for="name" class="block mb-2 text-sm font-medium text-gray-900 "> {{ labels["TITLE_SUPPLIER_PRICE"][lg] }}</label>
                    <input
                      id="price"
                      v-model="price"
                      v-focus
                      type="number"
                      name="price"
                      class="w-48 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-primary-600 focus:border-primary-600 block p-2.5      "
                      placeholder=""
                    />
                  </div>
                </div>

                <div class="mt-6 w-full text-left justify-left flex">
                  <div class="w-full ml-2 text-left justify-left">
                    <label for="name" class="block mb-2 text-sm font-medium text-gray-900 "> {{ labels["TITLE_SUPPLIER_ENTITIES"][lg] }}</label>

                    <ul class="w-96 px-3 pb-3 overflow-y-auto text-sm text-gray-700  inline-flex" aria-labelledby="dropdownSearchButton">
                      <li>
                        <div class="flex items-center pl-2 rounded hover:bg-gray-100 cursor-pointer">
                          <input
                            id="checkbox-item-13"
                            v-model="entity_a"
                            type="checkbox"
                            value=""
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    focus:ring-2  "
                          />
                          <label for="checkbox-item-13" class="w-full py-2 ml-2 text-sm font-medium text-gray-900 rounded ">Nemrod Alsace</label>
                        </div>
                      </li>
                      <li>
                        <div class="flex items-center pl-2 rounded hover:bg-gray-100 cursor-pointer">
                          <input
                            id="checkbox-item-12"
                            v-model="entity_b"
                            type="checkbox"
                            value=""
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    focus:ring-2  "
                          />
                          <label for="checkbox-item-12" class="w-full py-2 ml-2 text-sm font-medium text-gray-900 rounded ">Nemrod Sologne</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-between px-4">
          <div class="text-xs">#785#</div>
          <div class="flex items-center justify-end">
            <button
              type="button"
              class="mr-3 py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200      "
              @click="onClose()"
            >
              Annuler
            </button>
            <button
              type="button"
              class="inline-flex items-center text-white bg-gray-600 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center  "
              @click="onValidate"
            >
              Valider
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import labels from "@/assets/lg/supplier.json";
import service from "@/services/FullService.vue";
import { mapGetters } from "vuex";
import { Dropdown } from "flowbite";

export default {
  name: "SupplierModal",
  props: {
    input: Object,
  },
  computed: {
    ...mapGetters({ user: "StateUser" }),
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
  },
  data() {
    return {
      lg: "FR",
      labels: labels,
      id: null,
      query: "",
      suppliers: [],
      products: [],
      filtered_suppliers: [],
      supplier: {},
      supplier_id: null,
      supplier_name: "",
      quantity: 0,
      name: 0,
      price: 0,
      url: "",
      entity_a: "",
      entity_b: "",
      currency: "€",
      selected: {},
      reference: "",
      dropdown: null,
      transparent: false,
      item: {
        id: "1",
        label: {
          EN: "",
          FR: "",
        },
      },
    };
  },
  watch: {
    input: async function () {
      this.id = this.input?.id;
      this.price = this.input?.price;
      this.name = this.input?.name;
      (this.url = this.input?.url), (this.currency = this.input?.currency);
      this.reference = this.input?.reference;
      this.supplier = this.input?.supplier;

      this.supplier_name = this.input?.supplier_name;
      this.supplier_id = this.input?.supplier_id;
      if (this.supplier == null) this.supplier = {};
      if (typeof this.supplier == "string") this.supplier = {};

      this.supplier.name = this.input?.supplier_name;
      this.supplier._id = this.input?.supplier_id;

   this.supplier.image_id = this.input?.supplier_image_id;

      

      this.quantity = this.input?.quantity;

      if (this.input?.entity_id != undefined) {
        this.entity_a = this.input?.entity_id.includes("66a4a19c8d43c894c147758a"); //TODO
        this.entity_b = this.input?.entity_id.includes("66a4a1cb8d43c894c147758b");
      } else {
        this.entity_a = false;
        this.entity_b = false;
      }

      await this.loadSuppliers();
      // this.name = this.input
    },
  },
  async mounted() {
    this.id = this.input?.id;
    this.price = this.input?.price;
    this.currency = this.input?.currency;
    this.reference = this.input?.reference;
    this.supplier = this.input?.supplier;

    this.supplier_id = this.input?.supplier_id;
    this.supplier_name = this.input?.supplier_name;

    this.url = this.input?.url;
    this.quantity = this.input?.quantity;

    const options = {
      placement: "bottom",
      triggerType: "click",
      offsetSkidding: 0,
      offsetDistance: 10,
      delay: 300,
      ignoreClickOutsideClass: false,
      onHide: () => {
        // console.log('dropdown has been hidden');
      },
      onShow: () => {
        // console.log('dropdown has been shown');
      },
      onToggle: () => {
        //  console.log('dropdown has been toggled');
      },
    };

    const $targetEl = document.getElementById("dropdownSearchSuppliers");
    const $triggerEl = document.getElementById("dropdownSearchButtonSuppliers");

    if ($triggerEl != undefined) {
      this.dropdown = new Dropdown($targetEl, $triggerEl, options);
      // this.dropdown.hide()
    }
    await this.loadSuppliers();
  },

  methods: {
    selectProduct(item) {
      this.selected = item;
    },
    async loadProducts(supplier_id) {
      let source_id = "67e83dd7da880c78f3f9bbbd";
      let data = [];
      let limit = 100;
      let offset = 0;
      let filter = { supplier_id: supplier_id };
      let collection = "data-sources/" + source_id + "/records";
      // let collection = "ingredient-types"
      this.src = collection;
      data = await service.getData(collection, this.user?.token, Object.assign({}, { limit: limit, offset: offset }, filter));

      if (data == null) {
        data = [];
      }
      return data.records;
    },

    openSearch() {
      if (this.query == undefined) {
        this.filtered_suppliers = this.suppliers;
        return;
      }

      let q = this.query;
      let items = this.suppliers.filter(function (a) {
        if (a.name.toUpperCase().indexOf(q.toUpperCase()) == -1) return false;
        return true;
      });

      this.filtered_suppliers = items;
    },

    async selectSupplier(supplier) {
      this.supplier = supplier;
      this.supplier_id = supplier._id;
      this.supplier_name = supplier.name;

      this.supplier_image_id = supplier.image_id;


      //   this.products = await this.loadProducts(supplier._id);
      //  this.dropdown.toggle()
    },
    async loadSuppliers() {
      let source_id = "66185aed2cdd7ea01681abed"; // Liste des Fourniseurs
      let collection = "data-sources/" + source_id + "/records";
      let suppliers = await service.getData(collection, this.user?.token, { limit: 1000, sort: name });
      if (suppliers?.records != undefined) {
        this.suppliers = suppliers.records;
      } else {
        this.suppliers = [];
      }
      this.filtered_suppliers = this.suppliers;
    },
    onValidate() {
      let item = {
        id: this.id,
        name: this.name,
        price: this.price,
        currency: this.currency,
        quantity: this.quantity,
        url: this.url,
        reference: this.reference,
        supplier_id: this.supplier?._id,
        supplier_name: this.supplier?.name,

        supplier_image_id: this.supplier?.image_id,
        
        entity_id: [],
      };

      if (this.entity_a) item.entity_id.push("66a4a19c8d43c894c147758a");
      if (this.entity_b) item.entity_id.push("66a4a1cb8d43c894c147758b");

      this.$emit("confirm", item);
      // this.name = ""
    },
    onClose() {
      this.$emit("close");
      //  this.name = ""
    },
  },
  components: {},
};
</script>
